module.exports = __webpack_public_path__ + "img/fallback-small-hero-01.6297cd4.jpg";